import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'

import NProgress from 'vue-nprogress'
import Snotify, { SnotifyPosition } from 'vue-snotify'
//import 'vue-snotify/styles/material.css';
import '@/design/snotify-style.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from "vue-select";

import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store'
import Swal from "sweetalert2";
import SimpleBar from "simplebar-vue";

import VueCookies from 'vue-cookies-reactive'


// import VueAnalytics from 'vue-analytics';
// import SockJS from "sockjs-client";
// import Stomp from "webstomp-client";

import App from './App.vue'

import { initFirebaseBackend, refreshToken } from './authUtils'
import i18n from './i18n'

const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    icon: false,
    timeout: 2500,
    closeOnClick: true,
    pauseOnHover: true,
    maxOnScreen: 2,
    maxAtPosition: 2,
    preventDuplicates: true,
    //titleMaxLength: 110,
    //bodyMaxLength: 1110,
  }
};

Vue.component("v-select", vSelect);



Vue.use(SimpleBar)
Vue.component('simplebar', SimpleBar)





initFirebaseBackend();

Vue.use(VueRouter)
Vue.use(vco)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})

Vue.use(VueAxios, axios)
Vue.use(Snotify, options)


Vue.use(VueCookies)
Vue.$cookies.config('0','/','',true, 'Lax')


 
// const nprogress = new NProgress({ parent: '.nprogress-container' })
const nprogress = new NProgress()

const options2 = {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, default: 100,
  router: false, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, options2)


// AXIOS REQUESTS INTERCEPTOR
axios.interceptors.request.use((config) => {
    
    var token = sessionStorage.getItem('token')
    if (token != null) {
      config.headers.common['Authorization'] = "Bearer " + token;
    }    
    
    if (!config.url.startsWith("/api/notifications") && !config.url.startsWith("/api/auth/refresh") && !config.url.startsWith("/api/chat")  && !config.url.startsWith("/api/users/recentChatUsers")) {
      nprogress.set(0.6)
    }
    
    return config;
}, (error) => {
    nprogress.done();
    return Promise.reject(error);
});

// AXIOS RESPONSES INTERCEPTOR
axios.interceptors.response.use((response) => {
  nprogress.done();
  return response;
}, (error) => {

  nprogress.done();

  if (error == null || error.response == null) {
    return; 
  }

  if (error.response.status == 401) {
    return refreshToken(store).then( () => {
      error.config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      error.config.baseURL = undefined;
      return axios.request(error.config);
    }, () => {

      if(!error.response.config.url.startsWith("/api/notifications")) {

        Swal.fire(i18n.t('services.main.expired.title'), i18n.t('services.main.expired.body'), "warning")
        .then(() => {
          router.push({
              path:'/logout',
          });
        });
      }

    });
  }

  if (error.response.status == 409) {
    Swal.fire(i18n.t('services.main.singleSession.title'), i18n.t('services.main.singleSession.body'), "error")
    .then(() => {
      router.push({
          path:'/logout',
      });
    });

    return;    
  }
  
  if (error.response.status == 500) {
    Vue.prototype.$snotify.error(i18n.t('services.main.500error'));
    return
  }

  if (error.response.status == 404) {
    Vue.prototype.$snotify.error(i18n.t('services.main.404error'));
    return
  }

  if (error.response.status == 460) {
    router.push({
          path:'/device-validation',
      });
    return
  }

  if (error.response && error.response.data) {

    if (error.response.data.includes('<html')) {
      console.log(error.response.data)
      return
    }
    return Promise.reject(error.response.data);
  } else {
    return Promise.reject(i18n.t('services.main.500error'))
  }
});


Vue.component('apexchart', VueApexCharts)

// Event Bus for sharing events between components
export const eventBus = new Vue();

/*function longPolling(timestamp) {

  setTimeout(() => {

    var authToken = sessionStorage.getItem("token");
    if (authToken) {
    
      // console.log('started polling'+timestamp)
      NotificationsApi.getChatMsgCount(timestamp)
      .then(result => {
            if(!result.count) result.count = 0;

            if (result.count != -1) {
              eventBus.$emit("notif_chat_new", result.count);
            }
            
            // console.log('polling finished ' + result.count+" "+result.timestamp)
            longPolling(result.timestamp);
      })
    } else {
      // console.log('Not auth !!')
      longPolling(0);
    }
  }, 2000);
}*/

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),

  mounted: function(){

    /*var authToken = sessionStorage.getItem("token");
    if (!authToken) {
      return;
    }

    var headers={
      Authorization: 'Bearer ' + authToken
    };

    this.socket = new SockJS("/api/wsonotif", {headers : {Authorization : 'Bearer ' + authToken }});
    this.stompClient = Stomp.over(this.socket);
    
    this.stompClient.connect(
        headers,
        (frame) => {
        console.log(frame);
        this.stompClient.subscribe("/topic/" + sessionStorage.getItem("top"), tick => {
            eventBus.$emit("notif_chat_new", tick.body);
        });
        },
        error => {
        console.log(error);
        }
    );
    //uncomment to disable debugging
    //this.stompClient.debug = function() {};

    */

    //longPolling(0);

    

  }

}).$mount('#app')
